export const truncateText = (text: string | number, maxLength: number) => {
  const textString = String(text);
  if (textString.length <= maxLength) return textString;
  return textString.slice(0, maxLength) + '..';
};
